import { floorAnchorBounds } from '../../sim/engine.js';
import type { WorldState } from '../useSim.js';

/** Map aquarium NPC coords onto the stage rectangle; no furniture. */
export function fitAquariumWorld(world: WorldState, stageW: number, stageH: number): WorldState {
  if (stageW < 2 || stageH < 2) return world;
  const oldW = world.width ?? world.size;
  const oldH = world.height ?? world.size;
  const bounds = floorAnchorBounds(stageW, stageH);
  const mapX = (x: number): number => {
    const mapped = (x / oldW) * stageW;
    return Math.min(bounds.maxX, Math.max(bounds.minX, mapped));
  };
  const mapY = (y: number): number => {
    const mapped = (y / oldH) * stageH;
    return Math.min(bounds.maxY, Math.max(bounds.minY, mapped));
  };
  return {
    ...world,
    width: stageW,
    height: stageH,
    beds: [],
    mingle: true,
    runtime: world.runtime.map((r) => ({ ...r, x: mapX(r.x), y: mapY(r.y) })),
  };
}
